import React from "react";
import "styled-components/macro";
import { SimpleRadioGroup } from "../simple-radio";

export type QuoteSourceValue =
  | "Airline Agent"
  | "Aura"
  | "Google Flights"
  | "Other Website"
  | "Amadeus"
  | "Other GDS";
export const ALL_VALUES: QuoteSourceValue[] = [
  "Airline Agent",
  "Aura",
  "Google Flights",
  "Other Website",
  "Amadeus",
  "Other GDS",
];
const FIELD_LABEL = "Quote Source";
const FIELD_ID = "quoteSource";
const HELPER_TEXT = "What is the source of the quoted fare above?";

export function QuoteSourceInput({
  value,
  onValueChange,
  activeField,
  setActiveField,
}): JSX.Element {
  return (
    <SimpleRadioGroup
      selectedValue={value}
      setSelectedValue={onValueChange}
      allValues={ALL_VALUES}
      fieldLabel={FIELD_LABEL}
      fieldHelperText={HELPER_TEXT}
      fieldId={FIELD_ID}
      activeFieldId={activeField}
      setActiveFieldId={setActiveField}
    />
  );
}
